export const oddballBogGameId = 23;
export const oddballBetShopGameId = 22;

export const gameName = 'oddball';
export const gameNameForSocketAndFetch = 'oddball-bog';

export const socketGamePath = 'game';
export const socketBetShopPath = 'betshop';
